import request from '@/utils/request'
import config from '@/config/env'

// 获取有效作业日期
export function getValidDate(data) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/machineData/getJobDate',
        method: 'get',
        data
    })
}

// 获取地图数据信息
export function mapAreaInfo(data) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/statistics/maps',
        method: 'get',
        data
    })
}

// 获取数据统计
export function getDataCount(locId) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/statistics/overviews',
        method: 'get',
        data: { locId }
    })
}

// 获取作业农机统计
export function getJobMachineryCount(locId) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/statistics/machineJobInfos',
        method: 'get',
        data: { locId }
    })
}

// 获取农机数量及面积分布
export function getMachineryAndAreaCount(locId) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/statistics/machinsAndJobinfos',
        method: 'get',
        data: { locId }
    })
}

// 获取作业统计
export function getJobStatisticsCount(data) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/machineData/jobInfoStatistics',
        method: 'get',
        data
    })
}

// 获取合作社
export function getCooperativeOptions(locId) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/machineData/cooperativeOptions',
        method: 'get',
        data: { locId }
    })
}

// 获取农机主
export function getOwnerOptions(locId) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/machineData/farmMachineryOptions',
        method: 'get',
        data: { locId }
    })
}

// 获取乡镇地址
export function getTownOptions(locId) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/machineData/locInfoOptions',
        method: 'get',
        data: { locId }
    })
}

// 获取标点
export function getPoint(locId) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/machineData/queryMachineList',
        method: 'get',
        data: { locId }
    })
}

// 获取标点详情
export function getPointDetails(terminalCode) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/machineData/workCondition',
        method: 'get',
        data: { terminalCode }
    })
}

// 获取农机作业图片
export function getJobPictures(data) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/machineData/photoList',
        method: 'get',
        data
    })
}

// 获取农机作业历史轨迹
export function getTrajectory(data) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/machineData/traceInfoList',
        method: 'get',
        data
    })
}

// 获取农机作业查询列表
export function getJobQuery(data) {
    return request({
        baseURL: config.javaBase5,
        url: 'screen/machineData/jobInfoList',
        method: 'get',
        data
    })
}
